import React from "react";
import { string } from "prop-types";
import "./highlight-title.m.css";

export const HighlightTitle = ({ children }) => {
  return (
    <div styleName="highlight-title">{children}</div>
  );
};

HighlightTitle.propTypes = {
  children: string.isRequired,
};